import { gql } from '@apollo/client';

const Fragments = {
  itemProperty: gql`
    fragment itemProperty on ItemProperty {
      itemId
      propertyId
      propertyTypeCode
      propertyCode
      propertyName
      propertyValueTypeId
      propertyValueTypeCode
      mandatory
      defaultValue
      comments
    }
  `
};

export default Fragments;
